import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CowhidePencilSkirt = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.CowhidePencilSkirt.itemName}
      name={SS23.pants.CowhidePencilSkirt.itemName}
      price={SS23.pants.CowhidePencilSkirt.itemPrice}
      fabric={SS23.pants.CowhidePencilSkirt.itemFabric}
      src={SS23.pants.CowhidePencilSkirt.sizeChart}
      divId={SS23.pants.CowhidePencilSkirt.shopifyDivId}
      mainId={SS23.pants.CowhidePencilSkirt.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.CowhidePencilSkirt.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.CowhidePencilSkirt.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CowhidePencilSkirt;
